import TpEvaluatorSearchParams from './TpEvaluatorSearchParams';

export default class TpEvaluatorSchedulingSearchParams extends TpEvaluatorSearchParams {
  additionalInitialization() {
    this.TypeOfExport = 'SchedulingExport';
    this.Status = null;
    this.EmailOptOut = null;
    this.EmailOptOutPlaceholder = null;
    this.EmailVerified = null;
    this.EmailVerifiedPlaceholder = null;
    this.IncludeSelfDeactivated = null;
    this.IncludeSelfDeactivatedPlaceholder = null;
    this.TextAllow = null;
    this.TextAllowPlaceholder = null;
    this.IncludeNATextMessageAuthorized = null;
    this.IncludeNATextMessageAuthorizedPlaceholder = null;
  }
}
